import { ActionContainer } from "@/components/layout/ActionContainer";
import { SectionItem } from "@/features/tasks/SectionItem";
import { type Opportunity } from "@repo/api";
import { Button, historyIcon, mailIcon } from "@repo/skapa";
import { t } from "@repo/translation";
import { trackAnalytics } from "@repo/utils";
import { useState } from "react";

import { CommunicationHistoryModal } from "./CommunicationHistoryModal";
import { CommunicationModal } from "./CommunicationModal";

type ActiveModal = "COMMUNICATION" | "COMMUNICATION_HISTORY" | null;

interface CommunicationProps {
  opportunity: Opportunity;
  editable?: boolean;
}

export const Communication = ({ opportunity }: CommunicationProps) => {
  const [activeModal, setActiveModal] = useState<ActiveModal>(null);

  const openCommunication = () => {
    setActiveModal("COMMUNICATION");
    trackAnalytics("send_communication");
  };

  const openCommunicationHistory = () => {
    setActiveModal("COMMUNICATION_HISTORY");
    trackAnalytics("communication_history");
  };

  const closeModal = () => {
    setActiveModal(null);
  };

  return (
    <>
      <SectionItem title={t("label.customer_communication")}>
        <ActionContainer>
          <Button
            size="small"
            text={t("label.communication")}
            ssrIcon={mailIcon}
            onClick={openCommunication}
          />
          <Button
            size="small"
            text={t("label.communication_history")}
            ssrIcon={historyIcon}
            onClick={openCommunicationHistory}
          />
        </ActionContainer>
      </SectionItem>

      <CommunicationModal
        isOpen={activeModal === "COMMUNICATION"}
        onClose={closeModal}
        opportunity={opportunity}
      />

      <CommunicationHistoryModal
        isOpen={activeModal === "COMMUNICATION_HISTORY"}
        onClose={closeModal}
        opportunity={opportunity}
      />
    </>
  );
};
